import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Paper } from '@mui/material';
import { DataGrid, GridToolbar, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';
import { useStateIfMounted } from 'use-state-if-mounted'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { withRouter } from 'react-router-dom'

import {
    obtenerLoginPorTipoUsuario,
    actualizarLogin
} from '../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck'

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Portal, Typography } from '@mui/material';

import estilos from './UsuariosBeneficiariosComponent.module.css';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const style1 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
function UsuariosBeneficiariosComponent(props) {

    const dispatch = useDispatch()
    const solicitudes = useSelector(store => store.AtencionSolicitud.data)
    const dataUser = useSelector(store => store.Usuario.user)

    const usuariosBeneficiarios = useSelector(store => store.UsuariosAtencionACliente.usuariosBeneficiarios)
    const [password, setPasword] = React.useState('')
    const [verificarpassword, setVerificarPasword] = React.useState('')
    const [idlogin, setIdLogin] = React.useState('')
    const [verificar, setVerificar] = React.useState(false)
    React.useEffect(() => {
        dispatch(obtenerLoginPorTipoUsuario(2))
    }, [])

    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const handleOpenModal = (params) => {
        setIdLogin(params.row.idlogin)
        setTitleModal('Advertencia')
        setBodyModal('¿Esta seguro que desea cambiar la contraseña del usuario ' + params.row.usuario + '?')
        // setAccion(data.accion)
        setOpenModal(true)

    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setPasword('')
        setIdLogin('')
        setVerificarPasword('')
        setVerificar(false)
        setOpenModal(false)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style1}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>
                                <label style={{ textAlign: 'center' }}>Cambio de contraseña</label>
                            </center>
                            <center>
                                <div className="form-floating">
                                    <input type="password" name="password" className='form-control' id="floatinginput"
                                        value={password} onChange={e => setPasword(e.target.value)} />
                                    <label htmlFor="floatingInput">Ingrese la contraseña</label>
                                </div><br />
                                <div className="form-floating">
                                    <input type="password" name="password" className='form-control' id="floatinginput"
                                        value={verificarpassword} onChange={e => setVerificarPasword(e.target.value)} />
                                    <label htmlFor="floatingInput">Verifique la contraseña</label>
                                </div>
                                {verificar && <span className='text-danger' style={{ fontSize: 16 }}>Las contraseñas ingresadas no coinciden intente nuevamente</span>}
                            </center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <label style={{ textAlign: 'justify' }}>{bodyModal}</label> <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <div className='col-md-3'>
                                <button className='btn btn-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                            </div>
                            <div className='col-md-2 ms-5'></div>
                            <div className={`col-md-3`}>
                                <button className='btn btn-dark' onClick={() => { handleCloseModal() }}>CANCELAR</button>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    const botonGuardar = async () => {
        if (password === verificarpassword) {
            const data = { idlogin: idlogin, password: password }
            await dispatch(actualizarLogin(data))
            setTitleModal('')
            setBodyModal('')
            setPasword('')
            setIdLogin('')
            setVerificarPasword('')
            setVerificar(false)
            setOpenModal(false)
        } else {
            setVerificar(true)
        }

    }

    const columns = [

        /*{ field: 'id', headerName: 'ID', with: 30 },*/
        { field: 'num', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Id', width: 130, },
        { field: 'usuario', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Usuario', width: 370, },
        { field: 'contraseña', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Contraseña', width: 300, },
        { field: 'fecha', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Fecha Registro', width: 150, },
        {
            field: 'accion', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Acción', width: 220,
            renderCell: (params) =>
            (
                <button onClick={() => handleOpenModal(params)} className={`btn ${estilos.btnNaranja}`}>Cambiar Contraseña</button>
            )
        }
    ]
    const [id, setId] = React.useState()
    const rows = [];

    let numUser = 1
    usuariosBeneficiarios.map(usuario => {
        rows.push({ id: uuidv4(), num: numUser, usuario: usuario.usuario, contraseña: usuario.password, idlogin: usuario.idlogin, fecha: usuario.fechainscripcion !== null ? usuario.fechainscripcion.substring(0, 10) : '' })
        numUser++
    })

    const obtenerAncho = () => {
        const anchoPantalla = window.innerWidth
        return anchoPantalla
    }

    return (
        <div className='container'>
            <div className='row'>
                <h3 className='text-center tm'>Control de usuarios beneficiarios</h3><br />
                <div className='col-12 mt-1 ms-3 text-end' >
                    <div style={{ height: 600, width: obtenerAncho() < 1500 ? '105%' : '90%', color: 'black' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            pageSize={10}
                            components={{ Toolbar: GridToolbarQuickFilter }}
                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />
                    </div>
                </div>
                {modalComponent()}
            </div>
        </div>
    )
}
export default withRouter(UsuariosBeneficiariosComponent)
